// apps/frontend/src/hooks/useUpcomingFounderLive.ts
// Polls /api/v1/founder-lives/upcoming pour alimenter le bandeau global.
// Refresh discret toutes les 60s — assez pour catcher la transition
// SCHEDULED -> LIVE sans spammer l'API.

import { useEffect, useState } from 'react';
import apiClient from '../services/apiClient';

export interface FounderLiveDTO {
  id: string;
  title: string;
  description: string | null;
  scheduledAt: string;
  endsAt: string;
  externalUrl: string;
  thumbnailUrl: string | null;
  status: 'SCHEDULED' | 'LIVE' | 'ENDED' | 'CANCELLED';
}

const REFRESH_INTERVAL_MS = 60_000;

export function useUpcomingFounderLive() {
  const [live, setLive] = useState<FounderLiveDTO | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchLive = async () => {
      try {
        const res = await apiClient.request<{ live: FounderLiveDTO | null }>(
          '/api/v1/founder-lives/upcoming'
        );
        if (cancelled) return;
        if (res.success) {
          setLive((res.data as any)?.live ?? null);
        }
      } catch {
        // silencieux : pas critique
      }
    };

    fetchLive();
    const id = setInterval(fetchLive, REFRESH_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return live;
}
